<template>
    <el-dialog :title="id ? '修改关联商户信息' : '创建关联商户信息'" :visible.sync="showEditDialog" width="60%">
        <el-form :model="bindsInfo" :rules="rules" label-width="160px" ref="ruleForm">
            <el-form-item prop="accountName" label="商户名称">
                <el-input v-model="bindsInfo.accountName" placeholder="请输入汇付宝的商户名称" class="w-400" />
            </el-form-item>
            <el-form-item prop="accountId" label="商户号/登录号">
                <el-input v-model="bindsInfo.accountId" placeholder="请输入汇付宝的商户登录号" class="w-400" />
            </el-form-item>
            <el-form-item prop="accountType" label="商户账户类型">
                <el-select v-model="bindsInfo.accountType" class="w-400" placeholder="请选择账户类型 个人/商户">
                    <el-option v-for="item in accountTypeList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item prop="channel" label="支付渠道">
                <el-input v-model="bindsInfo.channel" class="w-400 channel" />
            </el-form-item>
            <el-form-item prop="merchantType" label="商户类型">
                <el-input v-model="bindsInfo.merchantType" placeholder="请简单描述下商户类型" class="w-400" />
            </el-form-item>
            <el-form-item prop="relationType" label="关系描述">
                <el-input v-model="bindsInfo.relationType" placeholder="请简单描述下商户与主商户之间的关系" class="w-400" />
            </el-form-item>
        </el-form>
        <div class="m-l-50">
            <el-button type="primary" @click="save('ruleForm')">保存</el-button>
            <el-button @click="showEditDialog = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  props: ['id'],
  data() {
    return {
      showEditDialog: false,
      channelList: [
        {
          label: '微信',
          value: 1,
        },
        {
          label: '支付宝',
          value: 2,
        },
      ],
      accountTypeList: [
        {
          label: '个人',
          value: 'userId',
        },
        {
          label: '商户',
          value: 'merchant',
        },
      ],
      rules: {
        accountName: { required: true, message: '您未输入汇付宝的商户名称', trigger: 'blur' },
        accountId: { required: true, message: '您未输入汇付宝的商户登录号', trigger: 'blur' },
        accountType: { required: true, message: '您未选择账户类型', trigger: 'blur' },
        channel: { required: true, message: '您未选择支付渠道', trigger: 'blur' },
      },
    };
  },
  computed: {
    ...mapGetters('merchants', ['searchForm', 'bindsInfo']),
  },
  methods: {
    ...mapActions('merchants', ['saveRelation', 'getBinds', 'getBindInfo','updateRelation']),
    openDialog(id) {
      this.showEditDialog = true;
      this.bindsInfo.accountName = '';
      this.bindsInfo.accountId = '';
      this.bindsInfo.merchantType = '';
      this.bindsInfo.accountType = '';
      this.bindsInfo.relationType = '';
      if (id) {
        this.getBindInfo({ bindCode: id });
      }
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id) {
            this.updateRelation(this.bindsInfo)
              .then(() => {
                this.$message.success('关联商户信息修改成功');
                this.showEditDialog = false;
                this.getBinds(this.searchForm);
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          } else {
            this.bindsInfo.mainMerchant=localStorage.getItem('merchantInfo')?JSON.parse(localStorage.getItem('merchantInfo')).hyUid:'';
            this.bindsInfo.mainMerchantName=JSON.parse(localStorage.getItem('checkdApply')).applyName;
            this.saveRelation(this.bindsInfo)
              .then(() => {
                this.$message.success('关联商户信息保存成功');
                this.showEditDialog = false;
                this.getBinds(this.searchForm);
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.w-400 {
  width: 400px;
}
.m-l-50 {
  margin-left: 50px;
}
.channel /deep/.el-input__inner {
  border: none;
}
</style>
